module.exports = __webpack_public_path__ + "assets/path-1-340036c5851080998db5e36f9ca7b39c.svg";